export const commonRealmName = `https://www.yiwanziyuan.com`
// export const commonRealmName = 'http://test.yiwanziyuan.com'
